(() => {
  const key = 'vorenie:saved-styles:v1';
  let saved = [];
  try { const data = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(data)) saved = data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string').slice(0, 100); } catch {}
  const safeUrl = value => { try { const url = new URL(value, location.origin); return url.origin === location.origin && url.pathname.includes('/products/') ? url.href : null; } catch { return null; } };
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(saved)); } catch {} };
  const refreshSaved = () => {
    document.querySelectorAll('[data-vm-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(item => item.id === button.dataset.vmSave))));
    const list = document.querySelector('[data-vm-saved-items]');
    const empty = document.querySelector('[data-vm-saved-empty]');
    if (!list) return;
    list.replaceChildren();
    for (const item of saved) {
      const url = safeUrl(item.url); if (!url) continue;
      const row = document.createElement('div'); row.className = 'vm-saved-item';
      const imageLink = document.createElement('a'); imageLink.href = url; imageLink.tabIndex = -1;
      if (item.image) { try { const source = new URL(item.image, location.origin); if (source.protocol === 'https:' && (source.origin === location.origin || source.hostname === 'cdn.shopify.com')) { const image = document.createElement('img'); image.src = source.href; image.alt = ''; image.width = 90; image.height = 90; image.loading = 'lazy'; imageLink.append(image); } } catch {} }
      const link = document.createElement('a'); link.href = url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.vmRemoveSaved = item.id; remove.textContent = '×'; remove.setAttribute('aria-label', document.getElementById('vm-wishlist')?.dataset.vmRemoveLabel || 'Remove');
      row.append(imageLink, link, remove); list.append(row);
    }
    if (empty) empty.hidden = list.children.length > 0;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-vm-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.vmOpen);
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault(); refreshSaved();
        if (!dialog.open) dialog.showModal();
        if (dialog.id === 'vm-search') dialog.querySelector('input')?.focus();
      }
    }
    const closer = event.target.closest('[data-vm-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('vm-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    const menuLink = event.target.closest('#vm-menu a');
    if (menuLink) document.getElementById('vm-menu')?.close();
    const button = event.target.closest('[data-vm-save]');
    if (button) {
      const id = button.dataset.vmSave;
      if (saved.some(item => item.id === id)) saved = saved.filter(item => item.id !== id);
      else if (safeUrl(button.dataset.url)) saved.push({ id, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image });
      persist(); refreshSaved();
    }
    const remove = event.target.closest('[data-vm-remove-saved]');
    if (remove) { saved = saved.filter(item => item.id !== remove.dataset.vmRemoveSaved); persist(); refreshSaved(); document.getElementById('vm-wishlist')?.querySelector('[data-vm-close]')?.focus(); }
  });
  const mobile = matchMedia('(max-width:749px)');
  const updateFooter = () => document.querySelectorAll('[data-vm-footer-details]').forEach(details => { details.open = !mobile.matches; });
  mobile.addEventListener('change', updateFooter);
  document.addEventListener('shopify:section:load', () => { updateFooter(); refreshSaved(); });
  document.addEventListener('shopify:block:select', event => {
    if (!(event.target instanceof Element)) return;
    const menu = event.target.closest('#vm-menu');
    const opener = event.target.closest('[data-vm-open]');
    const dialog = menu || (opener && document.getElementById(opener.dataset.vmOpen));
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    const details = event.target.closest('[data-vm-footer-details]');
    if (details) details.open = true;
  });
  document.addEventListener('shopify:block:deselect', event => {
    if (!(event.target instanceof Element)) return;
    const menu = event.target.closest('#vm-menu');
    const opener = event.target.closest('[data-vm-open]');
    const dialog = menu || (opener && document.getElementById(opener.dataset.vmOpen));
    if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
  });
  window.addEventListener('storage', event => { if (event.key === key) { try { const data = JSON.parse(event.newValue || '[]'); if (Array.isArray(data)) saved = data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string').slice(0, 100); } catch {} refreshSaved(); } });
  updateFooter(); refreshSaved();
})();
